<div class="launcher-update" *ngIf="(data.checking$ | async) === false; else checkingTpl">
    <h1 class="title">{{ 'launcherUpdateTitle' | translate }}</h1>
    <p class="message">{{ 'launcherUpdateMessage' | translate: { version: requiredVersion } }}</p>
    <div class="bays">
        <div class="row head">
            <span>{{ 'location' | translate }}</span>
            <span>{{ 'simulator' | translate }}</span>
            <span class="version">{{ 'launcherUpdateCurrent' | translate }}</span>
        </div>
        <div class="list">
            <div class="row" *ngFor="let bay of data.bays$ | async">
                <span>{{ bay.location }}</span>
                <span>{{ bay.bay }}</span>
                <span class="version">
                    <span class="chip">{{ bay.version || ('launcherUpdateNotReported' | translate) }}</span>
                </span>
            </div>
        </div>
    </div>
    <p class="hint">{{ 'launcherUpdateHint' | translate }}</p>
    <div class="actions">
        <button mat-button type="button" class="prm-btn fs-btn-txt refresh" [disabled]="checking" (click)="refresh()">
            {{ (checking ? 'launcherUpdateChecking' : 'launcherUpdateRefresh') | translate }}
        </button>
        <button mat-button type="button" class="fs-btn-txt sign-out" (click)="signOut()">
            {{ 'launcherUpdateSignOut' | translate }}
        </button>
    </div>
</div>
<ng-template #checkingTpl>
    <div class="launcher-update checking">
        <mat-spinner diameter="36"></mat-spinner>
        <p class="message">{{ 'launcherUpdateCheckingBays' | translate }}</p>
    </div>
</ng-template>
